import { render, staticRenderFns } from "./finance-szls-list.vue?vue&type=template&id=fd483f1a&scoped=true&"
import script from "./finance-szls-list.vue?vue&type=script&lang=js&"
export * from "./finance-szls-list.vue?vue&type=script&lang=js&"
import style0 from "./finance-szls-list.vue?vue&type=style&index=0&id=fd483f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd483f1a",
  null
  
)

export default component.exports